import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
  public disabled = false
  public status: { isopen: boolean } = { isopen: false }

  public toggled(open: boolean): void {}

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault()
    $event.stopPropagation()
    this.status.isopen = !this.status.isopen
  }

  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/layouts/full-layout.component.ts